import React from "react";
import { FaShieldAlt, FaRecordVinyl, FaClipboardCheck, FaLock, FaCreditCard, FaFileAlt, FaUserGraduate, FaPhoneAlt, FaHandshake, FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";

const ComplianceContent = () => {
  const complianceSections = [
    {
      id: 1,
      icon: <FaShieldAlt />,
      color: "blue-2-color",
      title: "TCPA & Telesales Compliance",
      items: [
        "No autodialing without explicit opt-in",
        "Calls only made to consent-based or opt-in leads",
        "Internal Do-Not-Call list management",
        "Federal & State DNC registry scrubbing",
        "Calls made only within permitted hours per state",
      ]
    },
    {
      id: 2,
      icon: <FaRecordVinyl />,
      color: "green-4-color",
      title: "100% Call Recording & Archival",
      items: [
        "All calls fully recorded and time-stamped",
        "Stored securely with encryption at rest",
        "Archived for minimum of 4 years",
        "Quick access for audits or dispute resolution",
      ]
    },
    {
      id: 3,
      icon: <FaClipboardCheck />,
      color: "pink-color",
      title: "Quality Assurance Framework",
      items: [
        "Daily live call audits and scoring",
        "Script adherence and product knowledge checks",
        "Weekly compliance reviews by QA team",
        "Order verification before submission",
        "Corrective action within 24 hours",
      ]
    },
    {
      id: 4,
      icon: <FaLock />,
      color: "orange-color",
      title: "Data Privacy & Security",
      items: [
        "Encrypted storage (AES-256)",
        "Secure transmission (TLS/HTTPS)",
        "Access-controlled systems",
        "We NEVER share or sell customer data",
      ]
    },
    {
      id: 5,
      icon: <FaCreditCard />,
      color: "blue-2-color",
      title: "PCI DSS & Payment Compliance",
      items: [
        "Secure, PCI-compliant payment workflows",
        "No storage of credit card numbers",
        "Partner-approved payment gateways",
        "Masking of sensitive information",
      ]
    },
    {
      id: 6,
      icon: <FaFileAlt />,
      color: "green-4-color",
      title: "Sales Scripts & Disclosures",
      items: [
        "Carrier-approved scripts",
        "Mandatory compliance disclosures",
        "Clear explanation of terms and pricing",
        "No exaggeration or misrepresentation",
      ]
    },
    {
      id: 7,
      icon: <FaUserGraduate />,
      color: "pink-color",
      title: "Agent Training & Certification",
      items: [
        "Telecom product training",
        "Sales ethics training",
        "Compliance certification",
        "Script mastery sessions",
        "Ongoing coaching and quality checks",
      ]
    },
    {
      id: 8,
      icon: <FaPhoneAlt />,
      color: "orange-color",
      title: "Outbound Calling Controls",
      items: [
        "Only opt-in and intent-based leads",
        "No random cold calling or robodialing",
        "No spoofing caller IDs",
        "Warm transfers and customer-initiated calls only",
      ]
    },
    {
      id: 9,
      icon: <FaHandshake />,
      color: "blue-2-color",
      title: "Ethical Business Practices",
      items: [
        "Zero tolerance for slamming or cramming",
        "No deceptive marketing or misrepresentation",
        "No unauthorized installations",
        "No high-pressure sales tactics",
        "Long-term relationships — not shortcuts",
      ]
    },
  ];

  return (
    <>
      {/* Page Header */}
      <section className="page__title-area pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">
              <div className="section__title section__title-3 text-center mb-45">
                <span>Our Commitment</span>
                <h2>Compliance & Quality Assurance</h2>
                <p className="mt-20">
                  At Vector Tech Solutions LLC, compliance is the foundation of every interaction,
                  every customer conversation, and every order we submit. We maintain strict adherence
                  to federal, state, and partner-specific regulations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Compliance Sections */}
      <section className="services__area pt-0 pb-90">
        <div className="container">
          <div className="row">
            {complianceSections.map((section, index) => (
              <div key={section.id} className="col-xl-4 col-lg-6 col-md-6">
                <div
                  className="services__item white-bg mb-30 compliance-card wow fadeInUp"
                  data-wow-delay={`.${index + 2}s`}
                  style={{
                    borderRadius: '20px',
                    padding: '35px 30px',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className="services__icon mb-25">
                    <i className={section.color} style={{ fontSize: '48px' }}>
                      {section.icon}
                    </i>
                  </div>
                  <h3 className="mb-20">{section.title}</h3>
                  <ul className="services__list">
                    {section.items.map((item, idx) => (
                      <li key={idx} className="mb-10">
                        <i className="green-4-color mr-10" style={{ fontSize: '12px' }}>
                          <FaCheck />
                        </i>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <div className="row mt-30">
            <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
              <div
                className="services__item text-center compliance-contact-box"
                style={{
                  borderRadius: '20px',
                  padding: '45px 40px',
                  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
                  background: 'rgba(255, 255, 255, 0.95)',
                  border: '1px solid rgba(87, 73, 255, 0.1)'
                }}
              >
                <h3 className="mb-20">Compliance Contact</h3>
                <p className="mb-25">
                  For compliance inquiries, audits, or verifications, please contact us:
                </p>
                <div className="mb-10"><strong>Email:</strong> contact@vectortechsol.com</div>
                <div className="mb-10"><strong>Phone:</strong> +1 574-218-6624</div>
                <div><strong>Location:</strong> 971 US HIGHWAY 202N, STE R, BRANCHBURG, NJ 08876</div>
                <div className="mt-30">
                  <Link to="/contact-us" className="z-btn">Contact Compliance Team</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ComplianceContent;
